import { Avatar, GuestAvatar } from '@octopus-do/octopus-storybook'
import type React from 'react'

import type { Recipient } from '@/types'

interface Props {
  author: Recipient | null
  size: 'sm' | 'md' | 'lg'
}

export const AuthorAvatar: React.FC<Props> = ({ author, size }) => {
  if (!author) {
    return <GuestAvatar size={size} />
  }
  return (
    <Avatar
      size={size}
      name={author.fullName}
      color={author.color}
      media={author.avatar}
    />
  )
}
